import { Component, Input } from "@angular/core";
import { ConversationJobOpportunityInfo } from "../../../../../api/messages/messages.types";

@Component({
  selector: "mh-chat-job-opportunity-info",
  templateUrl: "./mh-chat-job-opportunity-info.component.html",
  styleUrls: ["./mh-chat-job-opportunity-info.component.less"],
})
export class MhChatJobOpportunityInfoComponent {
  @Input() jobOpportunityInfo: ConversationJobOpportunityInfo | undefined;
}
